import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import RoomDetailLobby, { resolveWaitingMediaUrl } from '../../components/RoomDetailLobby';
import { ROUTE_ENUM } from '../../routes/RoutesConstant';
import { logger } from '../../utils/logger';
import { startTambolaRoomGame } from '../../network/network_callbacks';
import mqttService from '../../services/mqttService';
import { toast } from 'react-toastify';

const RapHousieRoomCodeShareStartGame = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const { roomName, roomType, createdRoomData, waitingMedia } = location.state || {};

  const [createdRoomCode, setCreatedRoomCode] = useState(createdRoomData?.roomCode || '');
  const createdRoomId = createdRoomData?.gameId || '';
  const [displayRoomName, setDisplayRoomName] = useState(
    createdRoomData?.roomName || roomName || ''
  );
  const [displayRoomType, setDisplayRoomType] = useState(
    createdRoomData?.roomType || roomType || ''
  );
  const [joinedUsersList, setJoinedUsersList] = useState([]);
  const [waitingMediaUrl, setWaitingMediaUrl] = useState(
    resolveWaitingMediaUrl(createdRoomData)
  );
  const hasNavigatedRef = React.useRef(false);

  useEffect(() => {
    logger.log('Rapchick RapHousieRoomCodeShareStartGame');
    if (createdRoomId) {
      mqttService.disconnect();
      startTambolaGame();
      connectMQTTAndGetJoinedUsersList();
    }
    return () => {
      mqttService.disconnect();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [navigate]);

  const navigateToLiveGame = (gameId) => {
    const id = gameId || createdRoomId;
    if (!id || hasNavigatedRef.current) return;
    hasNavigatedRef.current = true;
    navigate(ROUTE_ENUM.RAP_HOUSIE_GAME_LIVE.routePath, {
      replace: true,
      state: { nextGame: { gameId: id } },
    });
  };

  const connectMQTTAndGetJoinedUsersList = () => {
    try {
      logger.log('Connecting to MQTT for Room ID : ', createdRoomId);
      mqttService.connect('tambola/room/', createdRoomId, {
        'user-join': (payload) => {
          const joinedUsers = payload?.joinedUsers || [];
          setJoinedUsersList(joinedUsers);
        },
        start_game: (payload) => {
          navigateToLiveGame(payload?.gameId);
        },
        error: (err) => {
          console.error('MQTT error:', err);
        },
        complete: () => {
          logger.log('MQTT subscription complete');
        },
      });
    } catch (error) {
      console.error('MQTT connection error:', error);
    }
  };

  const startTambolaGame = async () => {
    try {
      logger.log('Starting Tambola Game for Room ID : ', createdRoomId);
      const response = await startTambolaRoomGame(createdRoomId);
      const data = response?.data?.data;
      const status = response?.data?.responseCode;

      logger.log('✅ Successfully startTambolaGame : ', data);

      if (status === 200 || status === 201) {
        setDisplayRoomName(data?.roomName || '');
        setDisplayRoomType(data?.roomType || '');
        setCreatedRoomCode(data?.roomCode || '');
        setJoinedUsersList(data?.joinedUserArr || []);
        const nextMediaUrl = resolveWaitingMediaUrl(data);
        if (nextMediaUrl) setWaitingMediaUrl(nextMediaUrl);
      } else {
        toast.error('Failed to load room. Please try again.');
      }
      return response;
    } catch (error) {
      console.error('❌ Failed to startTambolaGame : ', error);
    }
  };

  const handleCopyCode = () => {
    if (!createdRoomCode) return;
    navigator.clipboard.writeText(`${createdRoomCode}`);
    toast.success('Room Code copied to clipboard!');
  };

  const handleStartGame = () => {
    logger.log('Start Game Clicked:', displayRoomName, displayRoomType);
    navigateToLiveGame(createdRoomId);
  };

  return (
    <RoomDetailLobby
      roomName={displayRoomName}
      roomCode={createdRoomCode}
      members={joinedUsersList}
      mediaFile={waitingMedia || null}
      mediaUrl={waitingMediaUrl}
        onBack={() => navigate(ROUTE_ENUM.RAP_HOUSIE_ROOM_TYPE.routePath)}
      onCopyCode={handleCopyCode}
      onStartGame={handleStartGame}
      startDisabled={!createdRoomId}
    />
  );
};

export default RapHousieRoomCodeShareStartGame;
